export default __webpack_public_path__ + "images/SpeakersPhotos/HectorRobles.jpg?c1680fb9";